export default "__VITE_ASSET__C4o7pLyW__"